/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { FieldWrapper } from "../FieldWrapper";

import "./FieldExpandButton.scss";
import { FieldActionButton } from "../FieldActionButton";

export interface IFieldExpandButtonProps {
	readOnly?: boolean;
	className?: string;
	disabled?: boolean;
	onClick?: React.MouseEventHandler;
	selected?: boolean;
}

export const FieldExpandButton: React.FC<IFieldExpandButtonProps> = ({
	readOnly,
	disabled,
	className,
	onClick,
	selected
}) => {
	const baseClass = BEM("edt-field-expand-button");

	if (className) {
		baseClass.add(className);
	}

	return (
		<FieldWrapper type="expand-button">
			<FieldActionButton
				selected={selected}
				iconName="mdi/code-braces"
				className={baseClass.toClassName()}
				onClick={onClick}
				disabled={disabled || readOnly}
			/>
		</FieldWrapper>
	);
};
